import React from 'react';
import styled from 'styled-components';
import LazyLoad from 'react-lazyload';
import SingleDishItem from './SingleDishItem';

const DishItems = ({ dishes, searchedDishes, editDish, confirmDeleting }) => {
  if (searchedDishes) {
    if (searchedDishes.length === 0) {
      return (
        <DishesWrapper>
          <P>Нет совпадений</P>
        </DishesWrapper>
      );
    }
    return (
      <DishesWrapper>
        {searchedDishes.map((dish) => {
          return (
            <LazyLoad key={dish.id} height={120}>
              <SingleDishItem
                key={dish.id}
                editDish={editDish}
                confirmDeleting={confirmDeleting}
                dish={dish}
              />
            </LazyLoad>
          );
        })}
      </DishesWrapper>
    );
  }

  if (dishes) {
    return (
      <DishesWrapper>
        {dishes.map((dish) => {
          return (
            <LazyLoad key={dish.id} height={120}>
              <SingleDishItem
                key={dish.id}
                editDish={editDish}
                confirmDeleting={confirmDeleting}
                dish={dish}
              />
            </LazyLoad>
          );
        })}
      </DishesWrapper>
    );
  }

  return null;
};

export default DishItems;

const P = styled.p`
  width: 100%;
  text-align: center;
  font-size: 48px;
`;

const DishesWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
`;



// WEBPACK FOOTER //
// ./src/Components/Dishes/DishesList/DishItems.jsx